import { Navigate } from 'react-router-dom';
import DashboardHeader from '../header/DashboardHeader';
import methods from '../../services/utility';
import StepProgress from '../../views/public/stepProgress/StepProgress';

const SimpleLayout = ({ component: Component, ...rest }) => {

  const isUserLogedin = methods.checkUserLogin();

  return (
    <div className='container-fluid'>
      {isUserLogedin ?
        <>
          <DashboardHeader />
          <div className='row bg-light min-vh-100'>
            <StepProgress/>
            <Component {...rest} />
          </div>
        </>
        :
        <Navigate to="/login" />
      }
    </div>
  )
};

export default SimpleLayout;